import {
  deriveCapitalUSD,
  deriveDaysAgo,
  deriveExecutionSpeed,
  deriveRiskScore,
} from "./opportunityDerived";

/** Ordered list of sort options exposed in the listing UI. */
export const SORT_OPTIONS = [
  { value: "recommended", label: "الأنسب لك (افتراضي)" },
  { value: "score-desc", label: "الأعلى نقاطاً" },
  { value: "score-asc", label: "الأدنى نقاطاً" },
  { value: "capital-asc", label: "أقل رأس مال" },
  { value: "capital-desc", label: "أعلى رأس مال" },
  { value: "newest", label: "الأحدث" },
  { value: "oldest", label: "الأقدم" },
  { value: "fastest", label: "أسرع تنفيذاً" },
  { value: "risk-asc", label: "أقلّها مخاطرة" },
  { value: "risk-desc", label: "أكثرها مخاطرة" },
  { value: "title-asc", label: "العنوان (أ – ي)" },
  { value: "title-desc", label: "العنوان (ي – أ)" },
];

const NULL_LAST = (n) => (n === null || n === undefined ? Infinity : n);
const NULL_FIRST = (n) => (n === null || n === undefined ? -Infinity : n);

/** "Recommended" = balanced heuristic favouring score + confidence − risk. */
const recommendedRank = (o) => {
  const m = o.meta ?? {};
  return o.score * 1 + (m.confidence ?? 0) * 0.3 - deriveRiskScore(m) * 2;
};

/** Returns a sorted copy of the list, never mutates input. */
export const sortOpportunities = (list, sort) => {
  const arr = [...list];
  switch (sort) {
    case "recommended":
      return arr.sort((a, b) => recommendedRank(b) - recommendedRank(a));
    case "score-desc":
      return arr.sort((a, b) => b.score - a.score);
    case "score-asc":
      return arr.sort((a, b) => a.score - b.score);
    case "capital-asc":
      return arr.sort(
        (a, b) =>
          NULL_LAST(deriveCapitalUSD(a.meta)) -
          NULL_LAST(deriveCapitalUSD(b.meta)),
      );
    case "capital-desc":
      return arr.sort(
        (a, b) =>
          NULL_FIRST(deriveCapitalUSD(b.meta)) -
          NULL_FIRST(deriveCapitalUSD(a.meta)),
      );
    case "newest":
      return arr.sort(
        (a, b) => deriveDaysAgo(a.publishedAt) - deriveDaysAgo(b.publishedAt),
      );
    case "oldest":
      return arr.sort(
        (a, b) => deriveDaysAgo(b.publishedAt) - deriveDaysAgo(a.publishedAt),
      );
    case "fastest":
      return arr.sort(
        (a, b) => deriveExecutionSpeed(a.meta) - deriveExecutionSpeed(b.meta),
      );
    case "risk-asc":
      return arr.sort((a, b) => deriveRiskScore(a.meta) - deriveRiskScore(b.meta));
    case "risk-desc":
      return arr.sort((a, b) => deriveRiskScore(b.meta) - deriveRiskScore(a.meta));
    case "title-asc":
      return arr.sort((a, b) => a.title.localeCompare(b.title, "ar"));
    case "title-desc":
      return arr.sort((a, b) => b.title.localeCompare(a.title, "ar"));
    default:
      return arr;
  }
};
